import { BenQuery } from './BenQuery'
import Splide from '@splidejs/splide'
export class BenSc {
  static init(dones) {
    const $sw = BenQuery.query('[ben-js="sc"]')
    $sw.forEach(($item) => {
      if (dones.includes($item)) return
      dones.push($item)
      _init($item)
    })
  }
}

function _init($sc) {
  const direction = BenQuery.isRTL($sc) ? 'rtl' : 'ltr'
  const swObj = new Splide($sc, {
    direction,
    gap: '1rem',
    autoWidth: true,
    perPage: 3,
    // focus: 'center',
    pagination: true,
    arrows: true,
  })
  swObj.mount()
  setTimeout(() => {
    swObj.refresh()
  }, 300)
}
